<template>
  <div class="relative lg:py-0 md:py-0 lg:pt-0 md:pt-12 pt-12">
    <!-- <div class="absolute bg-design4 mob-hidden">
      <img
        src="../../../assets/images/bg-des/bgd4.svg"
        alt="bg-polygon"
        class=""
      />
    </div>
    <div class="absolute bg-design-cs mob-hidden">
      <img
        src="../../../assets/images/Ellipse 12.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="absolute bg-design-cs2 mob-hidden">
      <img
        src="../../../assets/images/Ellipse 12.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div> -->
    <!-- <div
      class="absolute top-0 left-0 h-full md:hidden lg:hidden block -mt-30px"
    >
      <img
        src="../../../assets/images/line/ww-line-2.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div> -->
    <p
      class="title md-fsize25 sm-fsize16 md:font-normal lg:font-normal font-bold font-bold"
    >
      Case Studies
    </p>
    <div
      class="lg:flex md:flex lg:gap-10 md:gap-10 items-center md:mb-0 lg:mb-0"
    >
      <div class="lg:w-1/2 md:w-1/2">
        <div class="relative">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Caregiver-Page/case-study.jpg"
            alt=""
            class="custborderradius"
          />
        </div>
      </div>
      <div class="lg:w-1/2 md:w-1/2 w-full z-10 lg:mt-0 md:mt-0 mt-4">
        <div class="relative">
          <p
            class="subtitle lg:pt-0 md:pt-0 pt-2 lh32px sm-lh26 sm-fsize13 italic"
          >
            “I watched my mother care for her every day, it was the same duties
            everyday”
          </p>
          <p
            class="subtitle lg:pt-10 md:pt-10 pt-2 lh32px sm-lh26 sm-fsize13 mob-hidden"
          >
            When Shibi was 13 years old, her grandmother Mercy was diagnosed
            with oral squamous cell carcinoma. Mercy had already become weak due
            to old age. She was 86 and the pain just made it worse. As cancer
            spread along the mandibular region, the doctors suggested palliative
            care at home. She was bedridden for almost two years. Shibi’s
            mother, Mary was the primary caregiver.
          </p>
          <p
            class="subtitle lg:pt-10 md:pt-10 pt-2 lh32px sm-lh26 sm-fsize13 italic"
          >
            ” In those days palliative care was unheard of. The children took
            care of their parents and elders.” 
          </p>
          <!-- <p
            class="subtitle lg:pt-10 md:pt-10 pt-2 lh32px sm-fsize14 mob-hidden"
          >
            Her mother, Mary like a dutiful daughter- in- law stepped into her
            caregiver role. Mary was a housewife and a doting mother of three
            children. She attended and cared for her mother-in-law in every way
            possible.
             Every day she would clean her room, bathe her, and help
            her to the bathroom. She would feed her, although she rarely ate.
            Shibi also recalls Mercy being too adamant and refusing to eat as
            the pain was unbearable. She says Mary patiently went through all of
            those tantrums and could be later seen crying in the kitchen………
          </p> -->
        </div>
        <div class="md:pt-10 lg:pt-10 pt-4">
          <base-button
            outline
            type="primary"
            class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 fs16700 border-2"
            @click="handleClick()"
            >Read More</base-button
          >
        </div>
      </div>
    </div>
    <!-- <div class="flex p-12">
      <img
        src="../../../assets/images/caregiver/our_servicenew.svg"
        alt=""
        class="m-auto banner-short-w450"
      />
      <div class="w42perc p-16 ">
        <div class="mt-16">
          <p class="title">Case Studies</p>
          <p class="subtitle pt-10 lh32px">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </p>
          <p class="subtitle pt-8 lh32px">
            Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
            officia deserunt mollit anim id est laborum. Excepteur sint occaecat
            cupidatat non proident, sunt in culpa qui officia deserunt mollit
            anim id est laborum.
          </p>
        </div>
        <div class="pt-10">
          <base-button
            outline
            type="primary"
            class="px-10 py-3 fs16700 border-2"
            >Read More</base-button
          >
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import casestudyMixin from "@/mixins/casestudy";

export default {
  mixins: [casestudyMixin],
  methods: {
    async handleClick() {
      // this.openCaseStudy(
      //   "Case Study: Alone we can do so little, together we can do so much"
      // );
      let data = await this.$store.dispatch("cms/GetPagesbyCategoryForBlog", {
        id: "61adf7f010718313e80bcc4b",
        search: "Starfish Stories: Gayathri's Testimonial",
      });
      // console.log(data.data.data[0]._id);
      const routeData = this.$router.resolve({
        name: "blogspage",
        params: {
          id: data.data.data[0]._id,
          slug: data.data.data[0]._id,
          // category: this.category,
        },
      });
      window.open(routeData.href, "_blank");
    },
    // https://caregiversaathi.co.in/insights/blogsPage/624d2da1420273444089cd65
  },
};
</script>
